import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Portal, Segment, Sidebar, Dimmer } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import Icon from '../../elementals/icon';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const baseElmId = 'drawer';
const SIDEBAR_SLIDE_TIME_MS = 500;
export const DIRECTIONS = {
    BOTTOM: 'bottom',
    RIGHT: 'right',
};
export const HEADER_STYLES = {
    LIGHT: 'light',
    INVERTED: 'inverted',
    CLEAR: 'clear',
};
class Drawer extends Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        title: PropTypes.node.isRequired,
        open: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        drawerRef: PropTypes.func,
        footerLeftButton: PropTypes.node,
        footerRightButton: PropTypes.node,
        footerPrimaryButton: PropTypes.node,
        footerSecondaryButton: PropTypes.node,
        progressBar: PropTypes.node,
        isWide: PropTypes.bool,
        direction: PropTypes.string,
        headerStyle: PropTypes.oneOf(Object.values(HEADER_STYLES)),
        closeOnDimmerClick: PropTypes.bool,
        elmId: PropTypes.string,
        infiniteScroll: PropTypes.bool,
    };
    static defaultProps = {
        drawerRef: _.noop,
        isWide: false,
        direction: DIRECTIONS.RIGHT,
        headerStyle: HEADER_STYLES.LIGHT,
        closeOnDimmerClick: true,
        infiniteScroll: false,
    };
    state = {
        sliderOpen: false,
        portalOpen: false,
        transitioning: false,
        hovering: false,
    };
    transitionCloseEnd = () => {
        this.drawerRef.removeEventListener('transitionend', this.transitionCloseEnd);
        setTimeout(() => {
            this.setState({ portalOpen: false, transitioning: false });
        }, SIDEBAR_SLIDE_TIME_MS);
    };
    togglePortalAndSlider = prevProps => {
        const { transitioning } = this.state;
        if (transitioning)
            return;
        if (!prevProps.open && this.props.open) {
            this.setState({
                portalOpen: true,
                sliderOpen: false,
                transitioning: true,
            });
            _.defer(() => {
                if (this.state.transitioning)
                    this.setState({ sliderOpen: true, transitioning: false });
            });
        }
        else if (prevProps.open && !this.props.open) {
            this.drawerRef.addEventListener('transitionend', this.transitionCloseEnd);
            this.setState({
                portalOpen: true,
                sliderOpen: false,
                transitioning: true,
            });
        }
    };
    componentDidMount() {
        this.togglePortalAndSlider({});
    }
    componentDidUpdate(prevProps) {
        this.togglePortalAndSlider(prevProps);
    }
    captureDrawerRef = ref => {
        const { drawerRef } = this.props;
        this.drawerRef = ref && ref.parentElement;
        if (drawerRef) {
            drawerRef(this.drawerRef);
        }
    };
    render() {
        const { children, title, onClose, footerLeftButton, footerRightButton, footerPrimaryButton: _footerPrimaryButton, footerSecondaryButton: _footerSecondaryButton, progressBar, isWide, direction, headerStyle, closeOnDimmerClick, elmId = baseElmId, infiniteScroll, } = this.props;
        const { portalOpen, sliderOpen } = this.state;
        const footerPrimaryButton = _footerPrimaryButton || footerLeftButton;
        const footerSecondaryButton = _footerSecondaryButton || footerRightButton;
        const showFooter = Boolean(footerPrimaryButton || footerSecondaryButton);
        return (_jsx(Portal, { open: portalOpen, children: _jsxs(Sidebar.Pushable, { as: Segment, basic: true, className: cx('container', direction === DIRECTIONS.RIGHT && isWide && 'wide', direction === DIRECTIONS.BOTTOM && 'bottom'), children: [_jsx(Sidebar, { as: 'div', animation: 'overlay', width: 'very wide', direction: direction, visible: sliderOpen, icon: 'labeled', onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, "data-elm-id": elmId, children: _jsxs("div", { ref: this.captureDrawerRef, className: cx('panel'), children: [_jsxs("div", { className: cx('header', headerStyle), "data-elm-id": `${elmId}_header`, children: [_jsx("div", { className: cx('title'), "data-elm-id": `${elmId}_title`, children: title }), _jsx("div", { className: cx('close-button', headerStyle), onClick: onClose, "data-elm-id": `${elmId}_close_button`, children: _jsx(Icon, { name: 'times', iconStyle: 'light', color: headerStyle === HEADER_STYLES.INVERTED
                                                    ? 'grayExtraLight'
                                                    : 'gray', hoverColor: headerStyle === HEADER_STYLES.INVERTED
                                                    ? 'offWhite'
                                                    : 'grayDark' }) })] }), _jsx("div", { className: cx('content', infiniteScroll && 'scrolling'), "data-elm-id": `${elmId}_content`, children: children }), showFooter && (_jsxs("div", { className: cx('footer'), "data-elm-id": `${elmId}_footer`, children: [progressBar, footerSecondaryButton, footerPrimaryButton] }))] }) }), _jsx(Dimmer, { active: true, page: true, className: cx('dimmer', { visible: sliderOpen }), onClick: closeOnDimmerClick ? onClose : _.noop })] }) }));
    }
}
export default Drawer;
//# sourceMappingURL=index.js.map